require('../proposals/promise-any');
require('../proposals/string-replace-all');
var parent = require('./4');

module.exports = parent;
